'use client';

import { c as _c } from "react/compiler-runtime";
import { ExploreProvider } from './ExploreProvider';
import { ExploreLayout } from './ExploreLayout';
function getParamValue(value) {
  if (Array.isArray(value)) return value[0] ?? null;
  return value ?? null;
}
export default function ExploreClient(t0) {
  const $ = _c(32);
  const {
    initialItems,
    initialPromotionMarkers,
    initialPromotionListItems,
    industriesData,
    attractionCategories,
    initialUrlParams: t1
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? {} : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const initialUrlParams = t2;
  let t3;
  if ($[2] !== initialUrlParams.view) {
    t3 = getParamValue(initialUrlParams.view);
    $[2] = initialUrlParams.view;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== initialUrlParams.community) {
    t4 = getParamValue(initialUrlParams.community);
    $[4] = initialUrlParams.community;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== initialUrlParams.types) {
    t5 = getParamValue(initialUrlParams.types);
    $[6] = initialUrlParams.types;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== initialUrlParams.search) {
    t6 = getParamValue(initialUrlParams.search);
    $[8] = initialUrlParams.search;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== initialUrlParams.promo) {
    t7 = getParamValue(initialUrlParams.promo);
    $[10] = initialUrlParams.promo;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== initialUrlParams.attr) {
    t8 = getParamValue(initialUrlParams.attr);
    $[12] = initialUrlParams.attr;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== initialUrlParams.promoid) {
    t9 = getParamValue(initialUrlParams.promoid);
    $[14] = initialUrlParams.promoid;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== t3 || $[17] !== t4 || $[18] !== t5 || $[19] !== t6 || $[20] !== t7 || $[21] !== t8 || $[22] !== t9) {
    t10 = {
      view: t3,
      community: t4,
      types: t5,
      search: t6,
      promo: t7,
      attr: t8,
      promoid: t9
    };
    $[16] = t3;
    $[17] = t4;
    $[18] = t5;
    $[19] = t6;
    $[20] = t7;
    $[21] = t8;
    $[22] = t9;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  const normalizedInitialParams = t10;
  let t11;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <ExploreLayout />;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== attractionCategories || $[26] !== industriesData || $[27] !== initialItems || $[28] !== initialPromotionListItems || $[29] !== initialPromotionMarkers || $[30] !== normalizedInitialParams) {
    t12 = <ExploreProvider initialItems={initialItems} initialPromotionMarkers={initialPromotionMarkers} initialPromotionListItems={initialPromotionListItems} industriesData={industriesData} attractionCategories={attractionCategories} initialUrlParams={normalizedInitialParams}>{t11}</ExploreProvider>;
    $[25] = attractionCategories;
    $[26] = industriesData;
    $[27] = initialItems;
    $[28] = initialPromotionListItems;
    $[29] = initialPromotionMarkers;
    $[30] = normalizedInitialParams;
    $[31] = t12;
  } else {
    t12 = $[31];
  }
  return t12;
}